import Head from "next/head";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";

export default function PuzzleBreadcrumbs({
  title,
  path,
  parent,
  includeHome = true,
}: {
  includeHome?: boolean;
  title: string;
  path: string;
  parent?: { name: string; path: string };
}) {
  const { t } = useTranslation("puzzles");
  const { locale, defaultLocale } = useRouter();
  const localePrefix =
    locale && locale !== (defaultLocale || "en") ? `/${locale}` : "";
  const items = [
    ...(includeHome ? [{ name: t("breadcrumbs.home"), path: "/" }] : []),
    ...(parent ? [parent] : []),
    { name: title, path },
  ];
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: items.map((item, i) => ({
                "@type": "ListItem",
                position: i + 1,
                name: item.name,
                item: `https://www.chesshotel.com${localePrefix}${item.path}`,
              })),
            }).replace(/</g, "\\u003c"),
          }}
        />
      </Head>
      <nav aria-label={t("breadcrumbs.label")} className="mb-4 text-sm text-slate-500">
        <ol className="flex flex-wrap gap-2">
          {items.map((item, i) => (
            <li key={item.path}>
              {i > 0 && (
                <span aria-hidden="true" className="mr-2">
                  /
                </span>
              )}
              {i === items.length - 1 ? (
                <span aria-current="page">{item.name}</span>
              ) : (
                <Link
                  href={item.path}
                  className="hover:underline"
                >
                  {item.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
